'use client';

import { useQuery } from '@tanstack/react-query';

import { LoyaltyProfile } from '@/domain/User/LoyaltyProfile';
import { Repositories } from '@/infra/repositories';

import { useUserResources } from './';

function useLoyaltyProfile<TData = LoyaltyProfile>(
  select?: (data: LoyaltyProfile) => TData
) {
  const { data: user } = useUserResources(
    LoyaltyProfile.userEligibleDataSelector
  );

  const isEligible = user ? LoyaltyProfile.isEligible(user) : false;

  return useQuery({
    queryKey: ['loyalty-profile', user?.id],
    queryFn: () => Repositories.User.getLoyaltyProfile(user!),
    staleTime: Infinity,
    enabled: isEligible,
    select,
  });
}

export default useLoyaltyProfile;
